import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M479.858-160Q460-160 446-174.142t-14-34T446.142-242t34-14T514-241.858q14 14.141 14 34Q528-188 513.858-174t-34 14m0-272Q460-432 446-446.142t-14-34T446.142-514t34-14T514-513.858q14 14.141 14 34Q528-460 513.858-446t-34 14m0-272Q460-704 446-718.142t-14-34T446.142-786t34-14T514-785.858q14 14.141 14 34Q528-732 513.858-718t-34 14" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }